export enum ProposalUserVoteType {
  Abstain = 'Abstain',
  No = 'No',
  Veto = 'Veto',
  Yes = 'Yes',
}
